module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "height": "100%"
    }
  }, [_c('div', [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "condensed": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Templates")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("search")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1), _vm._v(" "), _c('v-container', [_c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_vm._v("\n                left column...\n            ")]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, _vm._l((_vm.sections), function(section) {
    return _c('Section', {
      key: section.key,
      attrs: {
        "section": section
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "blue lighten-5",
    staticStyle: {
      "width": "300px",
      "height": "100%",
      "overflow-y": "auto"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "condensed": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Editor")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1), _vm._v(" "), _c('portal-target', {
    attrs: {
      "name": "sidebar"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bb2d7cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ItemList.vue
// module id = 2473
// module chunks = 1